module.exports = { "default": require("core-js/library/fn/object/get-own-property-descriptor"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// C:/Users/benw/Workspaces/LocalFarms/LocalMaps.UI/node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js
// module id = 857
// module chunks = 0